import { render, staticRenderFns } from "./List.vue?vue&type=template&id=1fb72467"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb72467')) {
      api.createRecord('1fb72467', component.options)
    } else {
      api.reload('1fb72467', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=1fb72467", function () {
      api.rerender('1fb72467', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rolesAndPermissions/List.vue"
export default component.exports